import {
  Avatar,
  Box,
  FormControl,
  InputAdornment,
  IconButton,
  Skeleton,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import { useTranslation } from 'react-i18next'
import jwt_decode from 'jwt-decode'

import {
  boxSize,
  fullWidth,
} from 'components/Reporting/Overview/ShareDashboard/StyleConstants'

type InputElementProps = {
  placeholder: string
  title: string
  values: any
  loader: any
  handleCopyClick: ({ placeholder }: { placeholder: string }) => void
  handleSwitchUpdate: (e: any) => void
  handleClickShowPassword: () => void
}
const InputElements = ({
  placeholder,
  title,
  values,
  loader,
  handleClickShowPassword,
  handleCopyClick,
}: InputElementProps) => {
  const { t } = useTranslation()
  const { showPassword } = values
  const switchName = values[`${placeholder}Switch`],
    switchLoader = loader[`${placeholder}Loader`]

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
  }

  const ReadOnlyInput = () => {
    const decodedPassword = (value: string) =>
      value?.length ? jwt_decode(value) : ''

    return (
      <Box sx={{ marginRight: 1, ...fullWidth }}>
        {!switchLoader ? (
          <FormControl sx={fullWidth}>
            <TextField
              sx={{
                '.MuiInputBase-input': {
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                },
              }}
              label={title}
              id="filled-start-adornment"
              defaultValue={
                placeholder === 'password'
                  ? decodedPassword(values[placeholder])
                  : values[placeholder]
              }
              type={
                placeholder === 'password'
                  ? showPassword
                    ? 'text'
                    : 'password'
                  : 'text'
              }
              variant="filled"
              inputProps={{
                'data-testid': `data-test-input-${placeholder}`,
              }}
              InputProps={{
                readOnly: true,
                endAdornment:
                  placeholder === 'password' ? (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ) : (
                    <div style={{ width: '5%' }}></div>
                  ),
              }}
            />
          </FormControl>
        ) : (
          <Skeleton height="40px" width="100%" variant="rectangular">
            <Typography>.</Typography>
          </Skeleton>
        )}
      </Box>
    )
  }

  const CopyComponent = () => {
    return (
      <Box>
        {!switchLoader ? (
          <Tooltip title={t('reporting.shareDetails.copy')}>
            <IconButton
              color="primary"
              onClick={() => {
                handleCopyClick({ placeholder })
              }}
              aria-label="delete"
              size="large"
            >
              <ContentCopyOutlinedIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Skeleton variant="circular">
            <Avatar />
          </Skeleton>
        )}
      </Box>
    )
  }

  const finalComponent = () => {
    return (
      <Box sx={boxSize}>
        <ReadOnlyInput />
        <CopyComponent />
      </Box>
    )
  }
  return switchName ? finalComponent() : null
}

export default InputElements
